const TopDestinations = {
  getTopDestinations: (countryId: number) => `TopDestination/Country/${countryId}`,
};

export default TopDestinations;
